import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { BasketTransactionResponse, CreditCardTransactionsRequest } from './creditCardOperationsModel'

export class basketOperationsService extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealerInformation/basketTransactions',
      requesterInfo,
    })
  }

  // Yalnızca sepet (basket) kredi kartı hareketlerini getirir.
  public async basketTransactions(req: CreditCardTransactionsRequest): Promise<BasketTransactionResponse[]> {
    return await this.postAsync<BasketTransactionResponse[]>(req)
  }
}
